import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../api/axios';
import toast from 'react-hot-toast';

const AcceptAdmin = () => {
  const { token } = useParams();
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();

  const handleAccept = async () => {
    setProcessing(true);
    try {
      await API.post(`/groups/admin-invite/${token}`);
      toast.success('أنت الآن أدمن في المجموعة ✅');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'فشل قبول الدعوة');
    } finally { setProcessing(false); }
  };

  useEffect(() => {
    // auto attempt if already logged
    if (token) handleAccept();
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', background: 'var(--bg-base)' }}>
      <div style={{ textAlign: 'center' }}>
        {processing ? (
          <p>جاري معالجة الدعوة...</p>
        ) : (
          <button className="btn btn-primary" onClick={handleAccept}>قبول الدعوة كأدمن</button>
        )}
      </div>
    </div>
  );
};

export default AcceptAdmin;
